var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E0E2E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#F0F1F3",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2929 10.2929C22.6834 9.90237 23.3166 9.90237 23.7071 10.2929C24.0976 10.6834 24.0976 11.3166 23.7071 11.7071L22.4142 13H28C29.1046 13 30 13.8954 30 15V17C30 17.9323 29.3621 18.7156 28.499 18.9372C28.4997 18.9581 28.5 18.979 28.5 19V28C28.5 29.1046 27.6046 30 26.5 30H13.5C12.3954 30 11.5 29.1046 11.5 28V19C11.5 18.979 11.5003 18.9581 11.501 18.9372C10.6379 18.7156 10 17.9323 10 17V15C10 13.8954 10.8954 13 12 13H17.5858L16.2929 11.7071C15.9024 11.3166 15.9024 10.6834 16.2929 10.2929C16.6834 9.90237 17.3166 9.90237 17.7071 10.2929L20 12.5858L22.2929 10.2929ZM19 15H12V17H19V15ZM19 19H13.5V28H19V19ZM21 28V19H26.5V28H21ZM21 17V15H28V17H21Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentProduct);
export default __webpack_public_path__ + "static/media/payment-product.898634e660ae7ae0c84b8172e8a00eb3.svg";
export { ForwardRef as ReactComponent };